export type OptionType =
  | 'group'
  | 'multi-checkbox'
  | 'single-radio'
  | 'boolean'
  | 'text'
  | 'number'
  | 'group-mode-checkbox';

// GroupOption: type is 'group' and 'field' is not required
export interface GroupOption {
  label: string;
  type: 'group' | 'group-mode-checkbox';
  showLabel?: boolean;
  options: MenuOption[]; // Assuming groups contain nested MenuOptions
  // 'field' is intentionally omitted
  // Other properties specific to 'group' can be added here
}

// NonGroupOption: type is anything except 'group' and 'field' is required
export interface NonGroupOption {
  label: string;
  type: Exclude<OptionType, 'group' | 'group-mode-checkbox'>; // Ensures type is not 'group'
  field: string; // 'field' is mandatory
  showLabel?: boolean;
  options?: MenuOption[]; // Optional, depending on your use case
  values?: string[];
  placeholder?: string;
  defaultValue?: any;
  // Other properties specific to non-group types can be added here
}

// Combine both interfaces into a union type
export type MenuOption = GroupOption | NonGroupOption;

export type UserMeta = {
  unique_user_id: string;
  username: string;
  creation_date: number;
  sent?: boolean;
}

export enum PostCaptureOptions {
  INLINE='INLINE',
  ALERT='ALERT'
}
